class AppSettings {

    get state(): IAppSettings  {
        if (window.__finja) {
            return window.__finja.settings;
        }

        return {} as IAppSettings;
    }
}

export interface IAppSettings {
    culture: string;
    pageId: string;
    webSiteId: string;
    languageId: string;
}

export default new AppSettings();
